import { REQUEST } from 'Stores'
import {
  CREATE_PORTFOLIO,
  DELETE_MEMBER_PORTFOLIO,
  DELETE_PORTFOLIO_BY_ID,
  GET_ALL_CUSTOMER,
  GET_ALL_MEMBER_IN_PORTFOLIO,
  GET_ALL_ROLES_PERMISSION,
  GET_ASSET_GOALS,
  GET_GROWTH_SCHEDULES,
  GET_PORTFOLIO_BY_ID, GET_PORTFOLIO_BY_ID_EDIT,
  GET_PORTFOLIO_BY_USERID, GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD, GET_VERIFY_INVITE_MEMBER_PORTFOLIO,
  POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO,
  POST_INVITE_MEMBER_PORTFOLIO,
  RESET_REDUCER,
  UPDATE_ASSET_GOALS,
  UPDATE_CURRENCY,
  UPDATE_GROWTH_SCHEDULES, UPDATE_PORTFOLIO_NAME,
  UPDATE_TIME_IPO
} from './constants'

export function createPortFolio(payload) {
  return {
    type: REQUEST(CREATE_PORTFOLIO),
    payload
  }
}

export function getAllCustomer(payload) {
  return {
    type: REQUEST(GET_ALL_CUSTOMER),
    payload
  }
}

export function getPortFolioByUserId(payload) {
  return {
    type: REQUEST(GET_PORTFOLIO_BY_USERID),
    payload
  }
}

export function getPortFolioByUserIdWithAction(payload) {
  return {
    type: REQUEST(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD),
    payload
  }
}

export function getPortFolioById(payload) {
  return {
    type: REQUEST(GET_PORTFOLIO_BY_ID),
    payload
  }
}

export function deletePortFolioById(payload) {
  return {
    type: REQUEST(DELETE_PORTFOLIO_BY_ID),
    payload
  }
}

export function updateTimeIPO(payload) {
  return {
    type: REQUEST(UPDATE_TIME_IPO),
    payload
  }
}

export function getAssetGoals(payload) {
  return {
    type: REQUEST(GET_ASSET_GOALS),
    payload
  }
}

export function getGrowthSchedules(payload) {
  return {
    type: REQUEST(GET_GROWTH_SCHEDULES),
    payload
  }
}

export function updateAnnualAssetGoals(payload) {
  return {
    type: REQUEST(UPDATE_ASSET_GOALS),
    payload
  }
}

export function updateGrowthSchedules(payload) {
  return {
    type: REQUEST(UPDATE_GROWTH_SCHEDULES),
    payload
  }
}

export function getPermissionRoles(payload) {
  return {
    type: REQUEST(GET_ALL_ROLES_PERMISSION),
    payload
  }
}

export function getAllMemberInPortfolio(payload) {
  return {
    type: REQUEST(GET_ALL_MEMBER_IN_PORTFOLIO),
    payload
  }
}

export function postInviteMemberPortFolio(payload) {
  return {
    type: REQUEST(POST_INVITE_MEMBER_PORTFOLIO),
    payload
  }
}

export function postAcceptedInviteMemberPortFolio(payload) {
  return {
    type: REQUEST(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO),
    payload
  }
}

export function getVerifyInviteMemberPortFolio(payload) {
  return {
    type: REQUEST(GET_VERIFY_INVITE_MEMBER_PORTFOLIO),
    payload
  }
}

export function deleteMemberPortFolio(payload) {
  return {
    type: REQUEST(DELETE_MEMBER_PORTFOLIO),
    payload
  }
}

export function updatePortfolioName(payload) {
  return {
    type: REQUEST(UPDATE_PORTFOLIO_NAME),
    payload
  }
}

export function getPortFolioByIdEdited(payload) {
  return {
    type: REQUEST(GET_PORTFOLIO_BY_ID_EDIT),
    payload
  }
}

export function resetReducer() {
  return {
    type: REQUEST(RESET_REDUCER)
  }
}

export function updateCurrency(payload) {
  return {
    type: REQUEST(UPDATE_CURRENCY),
    payload
  }
}
